import * as React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Tag } from "@emisgroup/ui-tag";
import {
  Environments,
  GetMkbVersionDetails,
  SuccessResponseType
} from "@emisgroup/cohort-builder-kit";
import { useUser } from "../../AuthContext";
import { Capitalize } from "../RightPanel/OutputConfig/Banding/Utilities";
import { handleException } from "../../ErrorMessages/helper";
import { ProgressSpinnerSlice } from "../ProgressSpinner/Index";
import SingOutIcon from "~icons/ic/outline-logout";

/**
 * Responsible for rendering banner actions
 */
export const BannerActions: React.FC = () => {

  const { logout } = useUser();
  const { t: translate } = useTranslation();
  const signOutLabel = translate("Button.LogoutButton");
  const env = process.env.APP_TARGET_ENV as Environments;
  const [mkbVersion, setMkbVersion] = React.useState<string>("");
  const dispatch = useDispatch();
  const { user } = useUser();

  /**
   * Method to get the latest mkb version details
   */
  const getMkbVersionDetails = async (): Promise<void> => {
    try {
      dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.GetMkbVersionDetails")));
      const response = await GetMkbVersionDetails(
        env,
        user?.token
      ) as SuccessResponseType;
      if (response?.data?.payload?.currentMkbVersion) {
        setMkbVersion(response?.data?.payload?.currentMkbVersion);
      }
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
    } catch (ex) {
      handleException(ex, dispatch, "GetMkbVersionDetails");
    }
  };

  /**
   * Initial load to get the mkb version details
   */
  React.useEffect(() => {
    getMkbVersionDetails();
  }, []);

  return (
    <div
      className="ebt-topbar__banner"
    >
      {mkbVersion &&
        <div className="ebt-topbar__banner-mkb">
          <Tag
            color="--deco-honey"
            textColor="--neutral-10"
          >
            {mkbVersion}
          </Tag>
        </div>
      }
      <div
        title="Current Environment"
        className="ebt-topbar__banner__environment-intimation"
      >
        <Tag
          color="--white"
          textColor="--neutral-10"
        >
          {Capitalize(process.env.APP_TARGET_ENV as string)}
        </Tag>
      </div>
      <div
        data-testid="signout-button"
        className="signout-button"
        onClick={logout}
      >
        {signOutLabel}
        <SingOutIcon title={signOutLabel} />
      </div>
    </div>
  );
};
